import React, { useEffect, useState } from 'react';
import './mleMakerChecker.scss';
import MleCheckerApprovalForm from './MleCheckerApprovalForm';
import { convertArrayToObject, filterSectionCheckerData } from './mleMakerChecker.utils';
import { MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';
import MerchantCheckerView from './MerchantCheckerView';

const MerchantDetailsAccordian = ({ data, additionalData, auth, isViewMode }) => {
  const [checkerRemarksData, setCheckerRemarksData] = useState([]);
  const [transformedData, setTransformedData] = useState({});
  const handleCheckerRemarksData = (section, updatedData) => {   
    setCheckerRemarksData(updatedData);
  };
  useEffect(() => {
      let transformedData = convertArrayToObject(checkerData?.checkerRemarks[0])
      setTransformedData(transformedData);
  }, []);
  
  const checkerData = filterSectionCheckerData(additionalData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.merchant);
  
  const currentEventType = checkerData?.eventType || '';
  const currentMakerRequestId = checkerData?.makerRequestId || '';
  
  const checkerLevel = checkerData?.approvalLevel || null;
  const remarks = checkerData?.remarks || null;
  const editedFields = checkerData?.editedFields || null;
  

  const levelMapping = {
    L1: 'L2',
    L2: 'L3',
    L3: null, 
  };
  const raisedToLevel = levelMapping[checkerLevel] || null;
  
  
  useEffect(() => {
    // update checker remarks data to json format 
    setTransformedData(checkerData?.checkerRemarks[0])
}, []);



  return (
    <div className="ownership-details-accordion">
      
          <MerchantCheckerView
            data={data}
            additionalData={checkerData?.checkerRemarks[0]}
            auth={auth}
            section='merchantDetails'
            handleCheckerRemarksData={handleCheckerRemarksData}
            isViewMode={isViewMode}
            editedFields={editedFields}
          />
      <MleCheckerApprovalForm
        raisedToLevel={raisedToLevel}
        requestDetails={{
          eventType: currentEventType.toUpperCase(),
          makerRequestId: currentMakerRequestId,
          status: additionalData?.status,
          remarks: remarks
        }}
        parentEventType = {additionalData?.eventType}
        checkerRemarks={checkerRemarksData}
        auth={auth}
        isViewMode={isViewMode}
      />
    </div>
  );
};

export default MerchantDetailsAccordian;
